<div class="wrapper">

    <main class="middle-content">
        <div class="page_title_block">
            <h1 class="page_title">Assessments & Forms</h1>
        </div>
        <div class="content-section">
            <div class="main-block-innner">
                <div class="add-store-block input-style mw-100">
                    <div class="form-user">
                        <div class="card">
                            <div class="card-body">

                                <!-- Title and program form start here  -->

                                <form [formGroup]="editAssessmentTitleForm" class="d-flex">
                                    <div class="justify-content-around d-flex">
                                        <label class="card-title col-md-2 text-nowrap">
                                            Title :
                                        </label>
                                        <div>
                                            <div>
                                                <input type="text" name="" placeholder="Add Title in English"
                                                    formControlName="addassessmentTitle" class="form-control col-md-12"
                                                    id="">
                                                @if(editAssessmentTitleForm.get('addassessmentTitle')?.hasError('required')
                                                && editAssessmentTitleForm.get('addassessmentTitle')?.dirty){
                                                <span>
                                                    <small class="text-danger">
                                                        *Title is required.
                                                    </small>
                                                </span>
                                                }
                                            </div>
                                            <br />
                                            <div>
                                                <input type="text" name="" placeholder="Add Title in Français"
                                                    formControlName="addassessmentTitleFR"
                                                    class="form-control col-md-12" id="">
                                                @if(editAssessmentTitleForm.get('addassessmentTitleFR')?.hasError('required')
                                                && editAssessmentTitleForm.get('addassessmentTitleFR')?.dirty){
                                                <span>
                                                    <small class="text-danger">
                                                        *Title is required.
                                                    </small>
                                                </span>
                                                }
                                            </div>
                                            <br />
                                            <div>
                                                <input type="text" name="" placeholder="Add Title in Español"
                                                    formControlName="addassessmentTitleES"
                                                    class="form-control col-md-12" id="">
                                                @if(editAssessmentTitleForm.get('addassessmentTitleES')?.hasError('required')
                                                && editAssessmentTitleForm.get('addassessmentTitleES')?.dirty){
                                                <span>
                                                    <small class="text-danger">
                                                        *Title is required.
                                                    </small>
                                                </span>
                                                }
                                            </div>
                                            <br />
                                        </div>

                                    </div>
                                    <!-- *************** select program section here ************************* -->
                                    <div class="ms-2">
                                        <select name="" class="custom-select"
                                            formControlName="addAssessmentProgramValue" id="">
                                            <option value="">Select Program</option>
                                            @for (item of programList; track item;let i = $index) {
                                            <option [value]="item._id">{{item?.title}}</option>
                                            }
                                        </select>
                                        @if(editAssessmentTitleForm.get('addAssessmentProgramValue')?.hasError('required')
                                        &&
                                        editAssessmentTitleForm.get('addAssessmentProgramValue')?.dirty){
                                        <span>
                                            <small class="text-danger">
                                                *Program is required.
                                            </small>
                                        </span>
                                        }
                                    </div>
                                    <!-- *************** select program section here ********************* -->
                                </form>

                                <form [formGroup]="editAssessmentForm" class="mt-4">
                                    <b>Intro:</b>
                                    <ul class="form-group row px-3" formArrayName="remarks">
                                        @for (remarks of editAssessmentForm?.controls.remarks['controls']; track
                                        remarks;let i = $index) {
                                        <div class="row p-3 border w-100 mb-3" formGroupName="{{i}}">
                                            <li class="py-2 d-flex">
                                                <span (click)="addRemark4()" class="d-flex w-100">
                                                    <i class="fa fa-plus addPlus ms-3"></i>
                                                </span>
                                            </li>
                                            <li class="py-2 d-flex">
                                                <!-- <span class="me-2">Remark {{i+1}}.</span> -->
                                                <div style="flex: 1;">
                                                    <input type="text" name="" placeholder="Type your remark in English"
                                                        formControlName="remark" class="form-control" id="">
                                                    <br />
                                                    <input type="text" name=""
                                                        placeholder="Type your remark in Français"
                                                        formControlName="remarkFR" class="form-control" id="">
                                                    <br />
                                                    <input type="text" name="" placeholder="Type your remark in Español"
                                                        formControlName="remarkES" class="form-control" id="">
                                                </div>
                                                @if(editAssessmentForm?.controls.remarks['controls'].length > 1){
                                                <i (click)="deleteRemark4(i)" class="fa fa-times addPlus ms-3"
                                                    aria-hidden="true"></i>
                                                }
                                            </li>
                                            <li>
                                        </div>
                                        }
                                    </ul>

                                    <b>Questions:</b>
                                    <ul class="form-group row px-3" formArrayName="QueArr4">
                                        @for (QueArr4 of editAssessmentForm?.controls.QueArr4['controls']; track
                                        QueArr4;let i = $index) {
                                        <div class="row p-3 border w-100 mb-3" formGroupName="{{i}}">
                                            <li class="py-2 d-flex">
                                                <span (click)="addUser4('',i)" class="d-flex w-100">
                                                    <label class="addQuestion active">Add New
                                                        Question</label>
                                                    <i class="fa fa-plus addPlus ms-3"></i>
                                                </span>
                                            </li>
                                            <li class="py-2 d-flex">
                                                <span class="me-2">Q{{i+1}}.</span>
                                                <div style="flex: 1;">
                                                    <input type="text" name=""
                                                        placeholder="Type your assessment in English"
                                                        formControlName="assessmentText" class="form-control" id="">
                                                    <br />
                                                    <input type="text" name=""
                                                        placeholder="Type your assessment in Français"
                                                        formControlName="assessmentTextFR" class="form-control" id="">
                                                    <br />
                                                    <input type="text" name=""
                                                        placeholder="Type your assessment in Español"
                                                        formControlName="assessmentTextES" class="form-control" id="">
                                                </div>
                                                @if(editAssessmentForm?.controls.QueArr4['controls'].length > 1){
                                                <i (click)="deleteUser4(i)" class="fa fa-times addPlus ms-3"
                                                    aria-hidden="true"></i>
                                                }
                                            </li>
                                            <li>
                                                <div class="d-flex align-items-center">
                                                    <div class="d-flex align-items-center">
                                                        <input type="radio" name="typeRadio" id="" disabled>
                                                        <label class="ms-2"> Yes </label>
                                                    </div>
                                                    <div class="d-flex align-items-center">
                                                        <input type="radio" name="typeRadio" disabled class="ms-3"
                                                            id="">
                                                        <label class="ms-2"> No </label>
                                                    </div>
                                                </div>
                                            </li>
                                            <!-- <li class="py-2 d-flex align-items-center">
                                            <span class="col-md-1 text-start p-0">Marks</span>
                                            <div class="col-md-2">
                                                <input type="text" (keypress)="service.inputKeyPress($event)" maxlength="2" formControlName="marks" class="form-control" >
                                            </div>
                                            </li> -->
                                        </div>
                                        }

                                        <li class="my-3 d-flex justify-content-center">
                                            <button class="btn btn-theme" (click)="updateAssessmentApi()"
                                                type="submit">Save</button>
                                            <button class="btn btn-danger ms-3" style="min-width: 100px;"
                                                (click)="back()" type="button">Back</button>
                                        </li>
                                    </ul>
                                </form>
                            </div>
                        </div>

                    </div>
                </div>
            </div>
        </div>
    </main>
</div>